import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';
import { RoutesV3Service } from '@core/services/entities-services/routes-v3.service';
import { SessionService } from '@core/services/session.service';
import { filter, Subject, takeUntil } from 'rxjs';
@Injectable({
  providedIn: 'root',
})
export class RoutesGuardActivate implements CanActivate {
  private destroy: Subject<void> = new Subject<void>();
  constructor(private routesService: RoutesV3Service, private _session: SessionService) {
  }
  canActivate(): boolean {
    if (!this.routesService.moduleStarted) {
      this._session.session.pipe(takeUntil(this.destroy), filter(session => session.services !== null)).subscribe(s => {
        this.routesService.loadConfigModule();
        this.routesService.moduleStarted = true;
        this.destroy.next();
      });
    }
    return true;
  }
}
